<section class="question" (copy)="blockCopy()" (cut)="blockCut()" appBlockPrint class="no-print">
  <header class="question__header has-person-id">
    <div class="question-timer question-timer--standalone" [ngClass]="{'question-timer--warning': isWarning}">
      <countdown [config]="{leftTime: 30 * 10,notify: [ 30 ]}" (event)="handleCountDownEvent($event)">$!m!:$!s!</countdown>
      Time
      Left
    </div>
    <h1 class="question__number">Question {{question.sequence}} of {{assessment.questionCount}}
    </h1>
    <div class="person-id">{{personId}}</div>
  </header>
  <div class="question__description rte-content watermarked" [innerHTML]="question.stem | safeHtml">
  </div>
  <div class="question-choices">
    <label class="question-choice question-choice--label" for="choice-{{i}}" tabindex="0" *ngFor="let option of question.options; let i=index">
      <input type="radio" id="choice-{{i}}" name="choice" class="question-choice__input is-vishidden" tabindex="-1"
        (change)="selectQuestionOptionId(option.questionOptionId)" [disabled]="!option.questionOptionId == selectedQuestionOptionId"
        required spellcheck="false"/>
      <div class="question-choice__text-wrap" [attr.data-letter]="letters[i]+' '">
        <span class="question-choice__text" [innerHTML]="option.text | safeHtml" spellcheck="false"></span>
      </div>
    </label>
  </div>
  <div class="form-actions">
    <input type="submit" [disabled]="selectedQuestionOptionId == null || selectedQuestionOptionId === ''" class="button form-actions__item"
      value="Submit" (click)="submitAnswer(null)" />
  </div>
  <small class="copyright">Copyright &copy; {{currentYear}}. The National Board for Respiratory Care, Inc. All rights
    reserved. FOR CONFIDENTIAL PERSONAL USE ONLY - DO NOT COPY, DISCLOSE, OR
    DISTRIBUTE ANY PART OR PORTION</small>  
</section>